import { render } from "./paymentConfigDetails.vue?vue&type=template&id=70fc7e4c&ts=true"
import script from "./paymentConfigDetails.vue?vue&type=script&lang=ts"
export * from "./paymentConfigDetails.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__